(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodToolTippy', sodToolTippy);

    function sodToolTippy(lodash, $timeout) {
        return {
            restrict: 'EA',
            transclude: true,
            templateUrl: 'common/components/sod-tool-tippy',
            link: sodToolTippyLink,
            controllerAs: 'vm',
            controller: sodToolTippyCtrl,
            bindToController: true,
            scope: {
                placement: '@',
                label: '=?',
                model: '=?',
                options: '=?',
                showTooltip: '&?',
                tippyClass: '@?'
            },
        };

        function sodToolTippyLink(scope, elem, attr) {
            var vm = scope.vm;
            var tippyInstance = null;
            var tippy = elem.find('.tippy');
            tippy = $(tippy);
            tippy.hide();


            var showTooltipVar = true;
            $timeout(function() {
               if (!showTooltop()) {
                   showTooltipVar = false;
               }

                $(elem).mouseenter(function (e) {
                    e.preventDefault();
                    if (showTooltipVar) {
                        tippy.hide();
                        toggleTippy();
                    }
                });

                $(elem).mouseleave(function (e) {
                    e.preventDefault();
                    if (showTooltipVar) {
                        tippy.show();
                        toggleTippy();
                    }
                });

            });


            function toggleTippy() {
                if (!tippyInstance) {
                    tippyInstance = new Popper(elem.children()[0], tippy, Object.assign({
                        placement: vm.placement ? vm.placement : 'auto',
                        positionFixed: true,
                        onCreate: function () {
                            tippyInstance.update();
                        },
                    }, lodash.get(vm, 'options', {})));
                    tippyInstance.scheduleUpdate();
                } else {
                    tippyInstance.update();
                }

                tippy.toggle();
            }

            function showTooltop() {
                if (typeof vm.showTooltip == typeof function() {}) {
                    return vm.showTooltip();
                }
                return true;
                // return false;
            }
        }

        function sodToolTippyCtrl() {
            var vm = this;
        }
    }
})();